import { AI, AIWriting, ChangeTone, Magic } from "./inline/AI";
import { AlignText } from "./inline/AlignText";
import { ApprovalAll, ApprovalOne, ApprovalOneAfter, ApprovalRequest } from "./inline/ApprovalRequest";
import { ArchivedIcons } from "./inline/Archive";
import { Arrow } from "./inline/Arrow";
import { Art } from "./inline/Art";
import { Attachment } from "./inline/Attachment";
import { Automation } from "./inline/Automation";
import { Bank } from "./inline/Bank";
import { Baseline } from "./inline/Baseline";
import { Batch } from "./inline/Batch";
import { Board } from "./inline/Board";
import { Book } from "./inline/Book";
import { Bookmark } from "./inline/Bookmark";
import { Brain } from "./inline/Brain";
import { Branch } from "./inline/Branch";
import { Bug } from "./inline/Bug";
import { Calendar } from "./inline/Calendar";
import { Case } from "./inline/Case";
import { Category } from "./inline/Category";
import { Chart } from "./inline/Chart";
import { Check } from "./inline/Check";
import { CheckboxChecked } from "./inline/CheckboxChecked";
import { Chevron } from "./inline/Chevron";
import { Clock } from "./inline/Clock";
import { ClockPlus } from "./inline/ClockPlus";
import { Code } from "./inline/Code";
import { Color } from "./inline/Color";
import { Columns } from "./inline/Columns";
import { Comment } from "./inline/Comment";
import { Conversion } from "./inline/Conversion";
import { Copy, CopyLink } from "./inline/Copy";
import { Cross } from "./inline/Cross";
import { Customer } from "./inline/Customer";
import { CustomField } from "./inline/CustomField";
import { Dashboard } from "./inline/Dashboard";
import { Delete } from "./inline/Delete";
import { Delivery } from "./inline/Delivery";
import { Dependency } from "./inline/Dependency";
import { Desktop } from "./inline/Desktop";
import { Details } from "./inline/Details";
import { Document } from "./inline/Document";
import { Drag } from "./inline/Drag";
import { Dropdown } from "./inline/Dropdown";
import { Duplicate } from "./inline/Duplicate";
import { Earth } from "./inline/Earth";
import { Edit } from "./inline/Edit";
import { Email } from "./inline/Email";
import { Emoji } from "./inline/Emoji";
import { Energy } from "./inline/Energy";
import { Eraser } from "./inline/Eraser";
import { Error, ErrorSmall } from "./inline/Error";
import { Export } from "./inline/Export";
import { Eye } from "./inline/Eye";
import { Feather } from "./inline/Feather";
import { File } from "./inline/File";
import { Filter } from "./inline/Filter";
import { Financial } from "./inline/Financial";
import { Flag } from "./inline/Flag";
import { Folder } from "./inline/Folder";
import { Follow, Unfollow } from "./inline/Follow";
import { AddRecord, Forms } from "./inline/Forms";
import { Formula } from "./inline/Formula";
import { Freeze } from "./inline/Freeze";
import { Gantt } from "./inline/Gantt";
import { Gear } from "./inline/Gear";
import { Ghost } from "./inline/Ghost";
import { GroupBy } from "./inline/GroupBy";
import { Header } from "./inline/Header";
import { Home } from "./inline/Home";
import { Hours } from "./inline/Hours";
import { House } from "./inline/House";
import { Import } from "./inline/Import";
import { InfinityIcon } from "./inline/Infinite";
import { Info } from "./inline/Info";
import { Internet } from "./inline/Internet";
import { Invoice } from "./inline/Invoice";
import { JobRole } from "./inline/JobRole";
import { Lab } from "./inline/Lab";
import { LinkInsert } from "./inline/LinkInsert";
import { List } from "./inline/List";
import { Lock } from "./inline/Lock";
import { Mapped } from "./inline/Mapped";
import { Master } from "./inline/Master";
import { Medicine } from "./inline/Medicine";
import { Mention } from "./inline/Mention";
import { Milestone } from "./inline/Milestone";
import { Mode } from "./inline/Mode";
import { Money, MoneyCheck } from "./inline/Money";
import { More } from "./inline/More";
import { MoveToSpace } from "./inline/MoveToSpace";
import { Music } from "./inline/Music";
import { MyAssignments } from "./inline/MyAssignments";
import { Notifications } from "./inline/Notifications";
import { Number } from "./inline/Number";
import { Office } from "./inline/Office";
import { OneDrive } from "./inline/OneDrive";
import { Paint } from "./inline/Paint";
import { Paragraph } from "./inline/Paragraph";
import { Pause } from "./inline/Pause";
import { Pen } from "./inline/Pen";
import { Picture } from "./inline/Picture";
import { Pin } from "./inline/Pin";
import { Plane } from "./inline/Plane";
import { Play } from "./inline/Play";
import { Plus } from "./inline/Plus";
import { Post } from "./inline/Post";
import { Print } from "./inline/Print";
import { PvcDetails } from "./inline/PvcDetails";
import { Redo } from "./inline/Redo";
import { Reference } from "./inline/Reference";
import { Repeat } from "./inline/Repeat";
import { Reports } from "./inline/Reports";
import { ResetTimer } from "./inline/ResetTimer";
import { Resource } from "./inline/Resource";
import { Risk } from "./inline/Risk";
import { Robot } from "./inline/Robot";
import { Rocket } from "./inline/Rocket";
import { Schedule } from "./inline/Schedule";
import { Scissors } from "./inline/Scissors";
import { Search } from "./inline/Search";
import { Separator } from "./inline/Separator";
import { Settings } from "./inline/Settings";
import { Share } from "./inline/Share";
import { SharedPlans } from "./inline/SharedPlans";
import { SharePoint } from "./inline/SharePoint";
import { Snapshot } from "./inline/Snapshot";
import { Sorting } from "./inline/Sorting";
import { Space } from "./inline/Space";
import { Spinner } from "./inline/Spinner";
import { Star } from "./inline/Star";
import { StarsAndChecks } from "./inline/StarsAndChecks";
import { Stop } from "./inline/Stop";
import { StopTimer } from "./inline/StopTimer";
import { Success, SuccessSmall } from "./inline/Success";
import { Support } from "./inline/Support";
import { Sweep } from "./inline/Sweep";
import { Table } from "./inline/Table";
import { ChangeType } from "./inline/TaskType";
import { Team } from "./inline/Team";
import { Template } from "./inline/Template";
import { Text } from "./inline/Text";
import { TextIndent } from "./inline/TextIndent";
import { Theater } from "./inline/Theater";
import { Tile } from "./inline/Tile";
import { TLetter } from "./inline/TLetter";
import { Tools } from "./inline/Tools";
import { TroubleIndication } from "./inline/TroubleIndication";
import { Umbrella } from "./inline/Umbrella";
import { Undo } from "./inline/Undo";
import { Unlink } from "./inline/Unlink";
import { Warning, WarningSmall } from "./inline/Warning";
import { Worker } from "./inline/Worker";
import { WorkStatus } from "./inline/WorkStatus";

const generalIcons = {
    ai: AI,
    ai_writing: AIWriting,
    approval_all: ApprovalAll,
    approval_one: ApprovalOne,
    approval_one_after: ApprovalOneAfter,
    approval_requests: ApprovalRequest,
    archive: ArchivedIcons.Archive,
    unarchive: ArchivedIcons.Unarchive,
    attachment: Attachment,
    auto_conversion: Conversion.Auto,
    automation: Automation,
    baseline: Baseline,
    batch: Batch,
    board: Board,
    bookmark: Bookmark.Empty,
    bookmark_filled: Bookmark.Filled,
    case: Case,
    category: Category,
    change_tone: ChangeTone,
    change_type: ChangeType,
    chart_bar: Chart.Bar,
    chart_metric: Chart.Metric,
    chart_pie: Chart.Pie,
    check: Check,
    checkbox_checked: CheckboxChecked,
    color_clear: Color.Clear,
    color_fill: Color.Fill,
    columns: Columns,
    comment: Comment.Empty,
    comment_filled: Comment.Filled,
    branch: Branch,
    copy: Copy,
    copy_link: CopyLink,
    cross: Cross,
    customer: Customer,
    custom_field: CustomField,
    dashboard: Dashboard,
    delete: Delete,
    dependency: Dependency,
    desktop: Desktop,
    drag: Drag,
    duplicate: Duplicate,
    edit: Edit,
    email: Email,
    emoji: Emoji,
    eraser: Eraser,
    eye: Eye.Show,
    eye_hide: Eye.Hide,
    fake: () => null as any,
    financial: Financial,
    flag_status: Flag.Status,
    follow: Follow,
    unfollow: Unfollow,
    forms: Forms,
    add_record: AddRecord,
    formula: Formula,
    freeze: Freeze,
    gantt: Gantt,
    groupBy: GroupBy,
    home: Home,
    info: Info,
    invoice: Invoice,
    job_role: JobRole,
    legend: Chart.Legend,
    lock: Lock,
    magic: Magic,
    manual_conversion: Conversion.Manual,
    mapped: Mapped.Yes,
    mention: Mention,
    milestone: Milestone,
    mode: Mode,
    money: Money,
    moneyCheck: MoneyCheck,
    more: More.Horizontal,
    my_assignments: MyAssignments,
    notifications: Notifications,
    number: Number,
    oneDrive: OneDrive,
    pause: Pause,
    pcv_details: PvcDetails,
    picture: Picture,
    pin: Pin.SimplePin,
    plane: Plane,
    play: Play,
    plus: Plus,
    dropdown: Dropdown,
    post: Post,
    print: Print,
    reset_timer: ResetTimer,
    reports: Reports,
    resource: Resource.Regular,
    resource_checked: Resource.WithCheck,
    resource_unnamed: Resource.Unnamed,
    resources: Resource.Team,
    risk: Risk,
    rocket: Rocket.SimpleRocket,
    scissors: Scissors,
    search: Search,
    settings: Settings,
    share: Share,
    shared_plans: SharedPlans,
    sharePoint: SharePoint.Brand,
    sharePoint_gray: SharePoint.Gray,
    snapshot: Snapshot,
    spinner: Spinner,
    star: Star,
    stars_and_checks: StarsAndChecks,
    stop: Stop,
    stop_timer: StopTimer,
    sweep: Sweep,
    table: Table,
    template: Template,
    tile: Tile,
    trouble_indicator: TroubleIndication,
    unlink: Unlink,
    unmapped: Mapped.No,
    user_with_timer: Resource.WithTimer,
    work_completed: WorkStatus.Completed,
    work_in_progress: WorkStatus.InProgress,
    work_paused: WorkStatus.Pause,
};

const arrowIcons = {
    arrow_left: Arrow.Left,
    arrow_right: Arrow.Right,
    arrow_left_short: Arrow.LeftShort,
    arrow_right_short: Arrow.RightShort,
    arrows_sync: Arrow.SyncHorizontal,
    export: Export,
    import: Import,
    details: Details,
    reference: Reference,
    repeat: Repeat,

    undo: Undo,
    redo: Redo,
};

const chevronIcons = {
    chevron_left: Chevron.Left,
    chevron_right: Chevron.Right,
    chevron_up: Chevron.Up,
    chevron_down: Chevron.Down,
    chevron_left_small: Chevron.LeftSmall,
    chevron_right_small: Chevron.RightSmall,
    chevron_up_small: Chevron.UpSmall,
    chevron_down_small: Chevron.DownSmall,
    collapse_left: Chevron.CollapseLeft,
    collapse_right: Chevron.CollapseRight,
    collapse_up: Chevron.CollapseUp,
    collapse_down: Chevron.CollapseDown,
};

const sortingIcons = {
    sorting: Sorting.Default,
    sorting_up: Sorting.Up,
    sorting_down: Sorting.Down,
    sorting_up_secondary: Sorting.UpSecondary,
    sorting_down_secondary: Sorting.DownSecondary,
    sorting_up_up: Sorting.UpUp,
    sorting_down_down: Sorting.DownDown,
    sorting_up_down: Sorting.UpDown,
    sorting_down_up: Sorting.DownUp,

    filter: Filter,
};

const dateIcons = {
    timer: Clock.Timer,
    hours: Hours,
    clock_3_quarters: Clock.Quarters3,
    clock_quarter: Clock.Quarter,
    calendar: Calendar.Simple,
    calendar_custom: Calendar.CustomDate,
    infinity: InfinityIcon,
    clock_plus: ClockPlus,
    clock_crossed_out: Clock.CrossedOut,
    clock_with_checkMark: Clock.CheckMark,
};

const textIcons = {
    align_center: AlignText.Center,
    align_justify: AlignText.Justify,
    align_left: AlignText.Left,
    align_right: AlignText.Right,
    indent_decrease: TextIndent.Decrease,
    indent_increase: TextIndent.Increase,
    link_insert: LinkInsert,
    list_check: List.Check,
    list_numbered: List.Numbered,
    text_bold: Text.Bold,
    text_color: Text.Color,
    text_italic: Text.Italic,
    text_strikethrough: Text.Strikethrough,
    text_styles: Text.Styles,
    text_underline: Text.Underline,

    list_bulleted: List.Bulleted,
    spelling: Text.Spelling,
    summarize: Text.Summarize,

    t_letter: TLetter,
    paragraph: Paragraph,
    header: Header,
    separator: Separator,
};

const fileIcons = {
    txt: File.Text,
    excel: File.Excel,
    pdf: File.Pdf,
    word: File.Word,
    zip: File.Zip,

    file: File.Simple,
    file_plus: File.Plus,
    file_check: File.Check,
    file_gear: File.Gear,

    external_image: File.ExternalImage,
    message: File.Message,
    presentation: File.Presentation,
    video: File.Video,
    audio: File.Audio,
    dimention_3d: File.Dimention_3d,
};

const stateIcons = {
    info: Info,
    success: Success,
    success_small: SuccessSmall,
    warning: Warning,
    warning_small: WarningSmall,
    error: Error,
    error_small: ErrorSmall,
};

const spaceIcons = {
    move_to_space: MoveToSpace,
    space: Space,
    doc: Document,
    book: Book,
    folder: Folder,
    medicine: Medicine,
    schedule: Schedule,
    space_pin: Pin.SpacePin,
    house: House,
    bank: Bank,
    office: Office,
    space_rocket: Rocket.SpaceRocket,
    code: Code,
    pen: Pen,
    gear: Gear,
    tools: Tools,
    paint: Paint,
    energy: Energy,
    brain: Brain,
    bug: Bug,
    feather: Feather,
    art: Art,
    lab: Lab,
    music: Music,
    theater: Theater,
    umbrella: Umbrella,
    delivery: Delivery,
    support: Support,
    ghost: Ghost,
    internet: Internet,
    earth: Earth,
    robot: Robot,
    master: Master,
    worker: Worker,
    team: Team,
};

export const internal = {
    generalIcons,
    arrowIcons,
    chevronIcons,
    sortingIcons,
    dateIcons,
    textIcons,
    fileIcons,
    spaceIcons,
    stateIcons,
};

export const icons = {
    ...generalIcons,
    ...arrowIcons,
    ...chevronIcons,
    ...sortingIcons,
    ...dateIcons,
    ...textIcons,
    ...fileIcons,
    ...spaceIcons,
    ...stateIcons,
} as const;
